import { render, staticRenderFns } from "./work_item_popover.vue.js?vue&type=template&id=70c9348f!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=template&id=70c9348f"
import script from "./work_item_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=script&lang=js"
export * from "./work_item_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=script&lang=js"
import style0 from "./work_item_popover.vue.css?vue&type=style&index=0&id=70c9348f&prod&lang=css!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=style&index=0&id=70c9348f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports